if (typeof Plugin_DeMinimis === 'undefined') {

    var Plugin_DeMinimis = {

        init: function () {
            $(document)
                .on('modal.button.miniform.close.pre', function (e, data) {
                    if (data.hasOwnProperty('miniformId')) {
                        // deminimis historie
                        if (20 === parseInt(data['miniformId'])) {
                            DynaCore_Item.miniformReload(21, 66);
                        }
                        // deminimis aktualizace
                        if (105 === parseInt(data['miniformId'])) {
                            window.location.reload(true);
                        }
                    }
                });
        },

        // vyhledání subjektu v registru
        findSubject: function () {

            var url = window.location.protocol + '//' + window.location.host;
            url += '/plugin/PluginDeMinimis/ajaxFindSubject';

            var idSection = $('#idSection').val();
            var idItem = $('#idItem').val();

            if (idSection.length) {
                url += '/' + idSection;
                if (idItem.length) {
                    url += '/' + idItem;
                }
            }

            // memcache hash
            var ch = $('#_ch');
            if (ch.length) {
                url += '?_ch=' + ch.val();
            }

            $.ajax({
                type: 'get',
                url: url,
                dataType: "json",
                global: true,
                beforeSend: function () {
                    Lemo_Alert.addInfo('DeMinimis - vyhledávám subjekt', 'DeMinimisFindSubjectBeforeSend');
                },
                complete: function () {
                    Lemo_Alert.closeById('DeMinimisFindSubjectBeforeSend');
                },
                success: function (r) {
                    if (r.hasOwnProperty('status') && true === r.status) {
                        if (r.hasOwnProperty('data')) {
                            var data = r.data;
                            if (data.hasOwnProperty('idDeMinimis')) {
                                $('#iddeminimis').val(data['idDeMinimis']);
                            }
                        }
                    }
                    if (r.hasOwnProperty('messages')) {
                        Lemo_Alert.addMany(r.messages);
                    }

                    var miniform = $('#miniformI66');
                    if (miniform.length) {
                        DynaCore_Item.miniformReload(21, 66);
                    }

                    miniform = $('#miniformI82');
                    if (miniform.length) {
                        DynaCore_Item.miniformReload(21, 82);
                    }

                    DynaCore_Item.refreshAction();
                },
                error: function () {
                    Lemo_Alert.addDanger('DeMinimis - vyhledání subjektu selhalo ...', 'DeMinimisFindSubjectError');
                }
            });
        },

        // načtení podpor subjektu
        loadSupports: function () {

            var url = window.location.protocol + '//' + window.location.host;
            var idSection = $('#idSection').val();
            var idItem = $('#idItem').val();

            url += '/plugin/PluginDeMinimis/ajaxLoadSupports';

            if (idSection.length) {
                url += '/' + idSection;
                if (idItem.length) {
                    url += '/' + idItem;
                }
            }

            // memcache hash
            var ch = $('#_ch');
            if (ch.length) {
                url += '?_ch=' + ch.val();
            }

            $.ajax({
                type: 'get',
                url: url,
                dataType: "json",
                global: true,
                beforeSend: function () {
                    Lemo_Alert.addInfo('DeMinimis - načítám aktuální podpory subjektu', 'DeMinimisLoadSupportsBeforeSend');
                },
                complete: function () {
                    Lemo_Alert.closeById('DeMinimisLoadSupportsBeforeSend');
                },
                success: function (r) {
                    if (r.hasOwnProperty('status') && true === r.status) {
                        if (r.hasOwnProperty('data')) {
                            var data = r.data;
                            if (data.hasOwnProperty('idDeMinimis')) {
                                $('#iddeminimis').val(data['idDeMinimis']);
                            }
                        }
                        DynaCore_Item.miniformReload(20, 59);
                    }
                    if (r.hasOwnProperty('messages')) {
                        Lemo_Alert.addMany(r.messages);
                    }

                    DynaCore_Item.miniformReload(21, 66);
                },
                error: function () {
                    Lemo_Alert.addDanger('DeMinimis - načtení podpor selhalo ...', 'DeMinimisLoadSupportsError');
                }
            });
        },

        // načtení účetních období subjektu
        loadPeriods: function () {

            var url = window.location.protocol + '//' + window.location.host;
            var idSection = $('#idSection').val();
            var idItem = $('#idItem').val();

            url += '/plugin/PluginDeMinimis/ajaxLoadPeriods';

            if (idSection.length) {
                url += '/' + idSection;
                if (idItem.length) {
                    url += '/' + idItem;
                }
            }

            // memcache hash
            var ch = $('#_ch');
            if (ch.length) {
                url += '?_ch=' + ch.val();
            }

            $.ajax({
                type: 'get',
                url: url,
                dataType: "json",
                global: true,
                beforeSend: function () {
                    Lemo_Alert.addInfo('DeMinimis - načítám aktuální účetní období subjektu', 'DeMinimisLoadPeriodsBeforeSend');
                },
                complete: function () {
                    Lemo_Alert.closeById('DeMinimisLoadPeriodsBeforeSend');
                },
                success: function (r) {
                    if (r.hasOwnProperty('status') && true === r.status) {
                        if (r.hasOwnProperty('data')) {
                            var data = r.data;
                            if (data.hasOwnProperty('idDeMinimis')) {
                                $('#iddeminimis').val(data['idDeMinimis']);
                            }
                        }
                        DynaCore_Item.miniformReload(102, 83);
                    }
                    if (r.hasOwnProperty('messages')) {
                        Lemo_Alert.addMany(r.messages);
                    }

                    // miniform historie
                    DynaCore_Item.miniformReload(21, 82);
                },
                error: function () {
                    Lemo_Alert.addDanger('DeMinimis - načtení účetních období selhalo ...', 'DeMinimisLoadPeriodsError');
                }
            });
        },

        // odeslání neodeslaných podpor
        sendSupport: function () {
            const datumPrideleni = $("#datumprideleni");
            if (!datumPrideleni.length) {
                return;
            }

            var url = window.location.protocol + '//' + window.location.host;
            var idSection = $('#idSection').val();
            var idItem = $('#idItem').val();

            url += '/plugin/PluginDeMinimis/sendSupportCheck';

            if (idSection.length) {
                url += '/' + idSection;
                if (idItem.length) {
                    url += '/' + idItem;
                }
            }

            // memcache hash
            var ch = $('#_ch');
            if (ch.length) {
                url += '?_ch=' + ch.val();
            }

            $.ajax({
                type: 'post',
                url: url,
                data: {datumPrideleni: datumPrideleni.val()},
                dataType: "json",
                global: true,
                success: function (r) {
                    if (r.hasOwnProperty('messages')) {
                        Lemo_Alert.addMany(r.messages);
                    }

                    if (true === r["data"]["showModal"]) {
                        let text = "<p class='text text-center'>";
                        text += "Datum přidělení podpory je po termínu zápisu do registru,<br> stav podpory bude pravděpodobně vyhodnocen jako 'Problémová'.";
                        text += "</p>";
                        text += '<div class="text-center">';
                        text += '<i class="fa fa-exclamation-triangle fa-fw fa-5x mt-3 mb-4 text-danger"></i>';
                        text += "</div>";
                        text += "<p class='text text-center'>";
                        text += "Opravdu si přejete podporu zapast?";
                        text += "</p>";

                        Lemo_Modal.setTitle('<i class="fas fa-fw fa-info-circle"></i> Upozornění' );
                        Lemo_Modal.setContent(text);
                        Lemo_Modal.addButton('cancel', '<i class="fas fa-fw fa-times"></i> Ne, nezapisovat', 'btn btn-secondary', function() {
                            Lemo_Modal.close();
                        });
                        Lemo_Modal.addButton('save', '<i class="fas fa-fw fa-check"></i> Ano, zapsat', 'btn btn-primary', function() {
                            var buttonSave = $(':button[name="saveContinue"]');
                            if (buttonSave.length) {
                                buttonSave
                                    .attr('name', 'saveAndSendSupport')
                                    .trigger('click');
                            }
                        });
                        Lemo_Modal.disableSubmitOnEnter();
                        Lemo_Modal.build(null);
                    } else {
                        var buttonSave = $(':button[name="saveContinue"]');
                        if (buttonSave.length) {
                            buttonSave
                                .attr('name', 'saveAndSendSupport')
                                .trigger('click');
                        }
                    }
                },
                error: function () {
                    Lemo_Alert.addDanger('DeMinimis - selhalo ověření data přidelení podpory ...', 'DeMinimisDateCheckError');
                }
            });
        },

        sendSupportCheck: function (datumPrideleni) {

        },


        // aktualizace podpory
        updateSupport: function () {

            var url = window.location.protocol + '//' + window.location.host;
            var idSection = $('#idSection').val();
            var idItem = $('#idItem').val();

            url += '/plugin/PluginDeMinimis/ajaxCancelSupport';

            if (idSection.length) {
                url += '/' + idSection;
                if (idItem.length) {
                    url += '/' + idItem;
                }
            }

            // memcache hash
            var ch = $('#_ch');
            if (ch.length) {
                url += '?_ch=' + ch.val();
            }

            $.ajax({
                type: 'get',
                url: url,
                dataType: "json",
                global: true,
                beforeSend: function () {
                    Lemo_Alert.addInfo('DeMinimis - ruším podporu v registru', 'DeMinimisCancelBeforeSend');
                },
                complete: function () {
                    Lemo_Alert.closeById('DeMinimisCancelBeforeSend');
                },
                success: function (r) {
                    if (r.hasOwnProperty('messages')) {
                        Lemo_Alert.addMany(r.messages);
                    }

                    DynaCore_Item.miniformReload(21, 82);
                },
                error: function () {
                    Lemo_Alert.addDanger('DeMinimis - odeslání podpory selhalo ...', 'DeMinimisCancelError');
                }
            });
        },

        // aktualizace číselníků
        updateLists: function (e) {

            e.preventDefault();
            $('#button-deminimis-update-lists').prop('disabled', true).attr('disabled', true);

            var url = window.location.protocol + '//' + window.location.host;
            url += '/plugin/PluginDeMinimis/ajaxUpdateLists';

            // memcache hash
            var ch = $('#_ch');
            if (ch.length) {
                url += '?_ch=' + ch.val();
            }

            $.ajax({
                type: 'get',
                url: url,
                dataType: "json",
                global: false,
                beforeSend: function () {
                    Lemo_Alert.addInfo('DeMinimis - aktualizuji číselníky', 'DeMinimisUpdateListsBeforeSend');
                },
                complete: function () {
                    Lemo_Alert.closeById('DeMinimisUpdateListsBeforeSend');
                    $('#button-deminimis-update-lists').prop('disabled', false).attr('disabled', false);
                },
                success: function (r) {
                    if (r.hasOwnProperty('messages')) {
                        Lemo_Alert.addMany(r.messages);
                    }
                },
                error: function () {
                    Lemo_Alert.addDanger('DeMinimis - aktualizace číselníků selahala ...', 'DeMinimisUpdateListsError');
                }
            })
        }
    };
}

$(document)
    .ready(function () {
        Plugin_DeMinimis.init();
        $('#button-deminimis-find-subject')
            .off('click')
            .on('click', function (e) {
                e.preventDefault();
                Plugin_DeMinimis.findSubject()
            });

        $('#button-deminimis-load-supports')
            .off('click')
            .on('click', function (e) {
                e.preventDefault();
                Plugin_DeMinimis.loadSupports()
            });

        $('#button-deminimis-load-periods')
            .off('click')
            .on('click', function (e) {
                e.preventDefault();
                Plugin_DeMinimis.loadPeriods()
            });

        $('#button-deminimis-send-support')
            .off('click')
            .on('click', function (e) {
                e.preventDefault();
                Plugin_DeMinimis.sendSupport()
            });

        $('#button-deminimis-update-lists')
            .off('click')
            .on('click', function (e) {
                e.preventDefault();
                Plugin_DeMinimis.updateLists(e)
            });
    });
